import { getApp } from '../App';
import { SessionExpiredError } from '../custom-errors/SessionExpiredError';

/**
 * Note: this decorator ensures that the session is still valid.
 * Therefore, a `keepAlive' request is sent for each function call.
 */
export function requireValidSession<ArgsType extends Array<unknown>, ReturnType>(
    target: object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...args: ArgsType) => Promise<ReturnType>>
): TypedPropertyDescriptor<(...agrs: ArgsType) => Promise<ReturnType>> {
    if (descriptor.value != null) {
        const method: ((...args: ArgsType) => Promise<ReturnType>) | undefined = descriptor.value;
        descriptor.value = async function(...args: ArgsType): Promise<ReturnType> {
            const app = await getApp();
            if (
                !app.eaiwsSession.isValid ||
                !await app.eaiwsSession.session.keepAlive()
            ) {
                throw new SessionExpiredError(new Error(`Function ${propertyKey} requires a valid session`));
            }

            return await method.apply(this, args);
        };
    }
    return descriptor;
}